import { StateCreator } from 'zustand';
import { Role, ProjectMember } from '../features/auth/types';
import { DEFAULT_ROLES } from '../features/auth/permissions';
import type { AppState } from './app-state';

export interface AdminSlice {
    admin: {
        roles: Role[];
        members: ProjectMember[];
    };
    adminActions: {
        setRoles: (roles: Role[]) => void;
        addRole: (role: Role) => void;
        updateRole: (roleId: string, updates: Partial<Role>) => void;
        deleteRole: (roleId: string) => void;
        setMembers: (members: ProjectMember[]) => void;
        addMember: (member: ProjectMember) => void;
        updateMember: (userId: string, updates: Partial<ProjectMember>) => void;
        removeMember: (userId: string) => void;
        clearAdmin: () => void;
    };
}

export const createAdminSlice: StateCreator<
    AppState & AdminSlice,
    [["zustand/immer", never]],
    [],
    AdminSlice
> = (set) => ({
    admin: {
        roles: [...DEFAULT_ROLES], // Initialize with default roles
        members: [],
    },
    adminActions: {
        setRoles: (roles) => set((state) => {
            state.admin.roles = roles;
        }),
        addRole: (role) => set((state) => {
            state.admin.roles.push(role);
        }),
        updateRole: (roleId, updates) => set((state) => {
            const index = state.admin.roles.findIndex((r) => r.id === roleId);
            if (index !== -1) {
                Object.assign(state.admin.roles[index]!, updates);

            }
        }),
        deleteRole: (roleId) => set((state) => {
            state.admin.roles = state.admin.roles.filter((r) => r.id !== roleId);
        }),
        setMembers: (members) => set((state) => {
            state.admin.members = members;
            // Also update cloud.member for the current user
            const currentUserId = state.auth.user?.uid;
            if (currentUserId) {
                const myMember = members.find(m => m.userId === currentUserId);
                if (myMember) {
                    state.cloud.member = myMember;
                }
            }
        }),
        addMember: (member) => set((state) => {
            state.admin.members.push(member);
        }),
        updateMember: (userId, updates) => set((state) => {
            const index = state.admin.members.findIndex((m) => m.userId === userId);
            if (index !== -1) {
                Object.assign(state.admin.members[index]!, updates);
                // Keep cloud.member in sync if updating current user
                if (userId === state.auth.user?.uid) {
                    state.cloud.member = state.admin.members[index]!;
                }

            }
        }),
        removeMember: (userId) => set((state) => {
            state.admin.members = state.admin.members.filter((m) => m.userId !== userId);
        }),
        clearAdmin: () => set((state) => {
            state.admin.roles = [...DEFAULT_ROLES];
            state.admin.members = [];
        }),
    },
});














